var map = {
	"./Sweety - 樱花草.flac": "f31c",
	"./Yang.Lc - 回忆太拥挤.flac": "dd68",
	"./乐柠组合 - 我们.flac": "6504",
	"./回忆录音带 - 风吹散人海 (变声版).flac": "d2e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4616";